import { loadStripe, Stripe, StripeError } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";

interface IUseStripeHook {
    stripeKey: string;
    practitionerStripeAccountId?: string;
}

interface IUseStripeHookResult {
    stripe: Stripe | null;
    loading: boolean;
}

export function useInitializeStripe({ stripeKey, practitionerStripeAccountId }: IUseStripeHook): IUseStripeHookResult {
    const [stripeError, setStripeError] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const [stripe, setStripe] = useState<Stripe | null>(null);

    useEffect(() => {
        const loadStripeInstance = async () => {
            try {
                setStripeError(null);
                const stripe = await loadStripe(stripeKey, {
                    stripeAccount: practitionerStripeAccountId,
                });

                if (stripe) {
                    setStripe(stripe);
                    setLoading(false);
                } else {
                    setStripeError("Failed to load Stripe");
                }
            } catch (error) {
                const typedError = error as StripeError;
                console.error("Error loading Stripe:", error);
                setStripeError(typedError.message);
            }
        };

        void loadStripeInstance();
    }, [stripeKey, practitionerStripeAccountId]);

    useEffect(() => {
        if (stripeError) {
            enqueueSnackbar(stripeError, {
                variant: "error",
                alertTitle: "Stripe error",
            });
        }
    }, [stripeError]);

    return {
        stripe,
        loading,
    };
}
